import React, { Fragment} from 'react'
import { Outlet } from 'react-router-dom';

const StaffRoute = () => {
    return (
        <div className="flex text-gray-700 text-sm overflow-x-hidden">
            <Fragment>
                <div className={"w-full h-[calc(100vh-64px)] overflow-y-auto p-4"}>
                    <Outlet />
                </div>
            </Fragment>
        </div>
    )
}

export default StaffRoute;
